import React from 'react';
import PropTypes from 'prop-types';
import './stylesheets/BlankState.scss';

export default function BlankState(props) {
  const { title, subtitle } = props;

  return (
    <div className="loc blank-state">
      <h2 className="blank-state-title">{ title }</h2>
      <p className="blank-state-subtitle">{ subtitle }</p>
    </div>
  );
}

BlankState.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.node
};

BlankState.defaultProps = {
  title: 'No Data'
};



// WEBPACK FOOTER //
// ./node_modules/@localytics/loc-components/lib/BlankState.jsx